import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enActions } from "@/shared/locales/en/actions";
import { enAppStudio } from "@/shared/locales/en/appStudio";
import { enAuth } from "@/shared/locales/en/auth";
import { enChat } from "@/shared/locales/en/chat";
import { enCommon } from "@/shared/locales/en/common";
import { enContextHub } from "@/shared/locales/en/contextHub";
import { enDataHub } from "@/shared/locales/en/dataHub";
import { enHome } from "@/shared/locales/en/home";
import { enLearningHistory } from "@/shared/locales/en/learningHistory";
import { enNuggets } from "@/shared/locales/en/nuggets";
import { enPublishedApps } from "@/shared/locales/en/publishedApps";
import { enRoles } from "@/shared/locales/en/roles";
import { enSettings } from "@/shared/locales/en/settings";
import { enSharedApps } from "@/shared/locales/en/sharedApps";
import { enTenants } from "@/features/admin/locales/en/tenants";
import { enUsers } from "@/shared/locales/en/users";

void i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  defaultNS: "common",
  ns: [
    "common",
    "home",
    "auth",
    "dataHub",
    "users",
    "appStudio",
    "publishedApps",
    "sharedApps",
    "nuggets",
    "chat",
    "settings",
    "roles",
    "tenants",
    "actions",
    "contextHub",
    "learningHistory",
  ],
  interpolation: { escapeValue: false },
  resources: {
    en: {
      common: enCommon,
      home: enHome,
      auth: enAuth,
      dataHub: enDataHub,
      users: enUsers,
      appStudio: enAppStudio,
      publishedApps: enPublishedApps,
      sharedApps: enSharedApps,
      nuggets: enNuggets,
      chat: enChat,
      settings: enSettings,
      roles: enRoles,
      tenants: enTenants,
      actions: enActions,
      contextHub: enContextHub,
      learningHistory: enLearningHistory,
    },
  },
});

export default i18n;
